import React from 'react'
import styled from 'styled-components'
import { Box, useMediaSize, Icon, TextBody } from '@ally/metronome-ui'
import { muiRefresh, muiErrorFill } from '@ally/metronome-icons'
import { useAccountTypes } from '../AccountTypeContext'

import {
  isAutoPayVehicleAccount,
  isAutoAccountPastDue,
  getAccountNickname,
  getMaskedAccountNumber,
  getReadablePastDueDate,
  getReadablePastDueAmount,
  getReadableDueDate,
  getReadableNextPaymentAmount,
} from './utils'

const Wrapper = styled(Box)<{ isMdDown: boolean }>`
  ${({ theme: { colors, space }, isMdDown }): string => `
    border-top: 1px solid ${colors['slate-2']};
    display: flex;
    align-items: center;
    padding: ${space.sm} ${space.sm} ${space.xs} 0;
    padding-left: ${isMdDown ? space.xs : 0};
  `};
`

export const VehicleAccountWell: React.FC = () => {
  const isMdDown = useMediaSize('MdDown')
  const { allAutoAccounts } = useAccountTypes()

  const autoPayAccount = allAutoAccounts.find(acct =>
    isAutoPayVehicleAccount(acct),
  )

  const pastDueAccount = allAutoAccounts.find(acct =>
    isAutoAccountPastDue(acct),
  )

  return (
    <>
      {autoPayAccount && (
        <Wrapper isMdDown={isMdDown} data-testid="vehicle-account-well">
          <Icon icon={muiRefresh} size="md" mx="xs" fill="plum" />
          <TextBody tag="span" size="sm">
            Your payment of{' '}
            <b>{getReadableNextPaymentAmount(autoPayAccount)}</b> will be
            deducted from your account on {getReadableDueDate(autoPayAccount)}.
          </TextBody>
        </Wrapper>
      )}
      {pastDueAccount && (
        <Wrapper isMdDown={isMdDown} data-testid="vehicle-account-well">
          <Icon
            icon={muiErrorFill}
            aria-label="Warning"
            size="md"
            mx="xs"
            fill="error"
          />
          <TextBody tag="span" size="sm">
            You owed <b>{getReadablePastDueAmount(pastDueAccount)}</b> on{' '}
            {getAccountNickname(pastDueAccount)}
            {getMaskedAccountNumber(pastDueAccount)} on{' '}
            {getReadablePastDueDate(pastDueAccount)}.
          </TextBody>
        </Wrapper>
      )}
    </>
  )
}
